import React from 'react';
import { CtaButton } from './CtaButton';
export function HeroSection() {
  return <section className="pt-6 pb-8 px-4 bg-white text-center" data-id="element-73">
      <div className="max-w-4xl mx-auto" data-id="element-74">
        <div className="mb-2 animate-[fadeInUp_0.6s_ease-out_both]" data-id="element-75">
          <p className="text-base md:text-lg font-bold text-red-600 uppercase tracking-widest mb-2" data-id="element-76">
            ¿Cansada de dietas que no funcionan?
          </p>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-gray-900 leading-tight uppercase" data-id="element-77">
            🥗 MEGAPACK
            <br data-id="element-78" />
            ALIMENTACIÓN SALUDABLE
          </h1>
          <div className="mt-3 inline-block bg-black text-white px-5 py-1.5 rounded-full" data-id="element-79">
            <p className="text-sm md:text-base font-black uppercase tracking-wide" data-id="element-80">
              Comé Rico • Bajá de Peso • Sin Azúcar ni Harinas
            </p>
          </div>
        </div>

        <p className="text-lg md:text-2xl font-bold text-gray-800 mb-2 max-w-2xl mx-auto leading-snug animate-[fadeInUp_0.5s_ease-out_0.2s_both]" data-id="element-81">
          El sistema completo para transformar tu alimentación
          <span className="text-green-600" data-id="element-82"> sin esfuerzo</span>,
          <span className="text-green-600" data-id="element-83"> sin dietas extremas</span> y
          <span className="text-green-600" data-id="element-84"> sin contar calorías.</span>
        </p>

        {/* Fixed aspect ratio container prevents CLS */}
        <div className="-mb-4 relative overflow-hidden animate-[fadeInScale_0.6s_ease-out_0.3s_both]" style={{
        aspectRatio: '1 / 1',
        maxWidth: '448px',
        margin: '0 auto',
        marginBottom: '-1rem',
        contain: 'layout'
      }} data-id="element-85">
          <img src="https://cdn.magicpatterns.com/uploads/921ZXerDwyfauhtmYMPMc4/libro_abanico_todos_los_productos_sin_fondo.png" alt="Megapack Alimentación Saludable" className="w-full h-full object-contain cursor-pointer" width="448" height="448" fetchPriority="high" decoding="sync" onClick={() => {
          document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} data-id="element-86" />
        </div>

        <div className="mb-4 animate-[fadeInUp_0.5s_ease-out_0.5s_both]" data-id="element-87">
          <p className="font-bold text-gray-900 bg-yellow-100 inline-block px-4 py-2 rounded-lg text-sm md:text-base" data-id="element-88">
            👉 Recetas simples, planes listos y organización total para lograr
            resultados reales.
          </p>
        </div>

        <div className="flex flex-col items-center animate-[fadeInUp_0.5s_ease-out_0.6s_both]" data-id="element-89">
          <CtaButton text="👉 QUIERO EMPEZAR A COMER MEJOR HOY" data-id="element-90" />
          <p className="text-xs text-gray-500 font-semibold uppercase tracking-wider mt-2" data-id="element-91">
            Descarga inmediata • Garantía de 7 días
          </p>
        </div>
      </div>
    </section>;
}